export default __webpack_public_path__ + "static/01-02-reading-annotation-exercises-e96a1dcb016c93c8e9eec9c03bc92682.mp4";